import React from 'react';
import { ReactComponent as LockIcon } from 'new/components/icons/lock.svg';
import { ReactComponent as SourceIcon } from 'new/components/icons/fi-rr-exit.svg';
import { ReactComponent as KeyIcon } from 'new/components/icons/key.svg';
import { ReactComponent as DestinationIcon } from 'new/components/icons/fi-rr-arrow-right-to-bracket.svg';
import { ReactComponent as FlowIcon } from 'new/components/icons/fi-rr-diagram-subtask.svg';
import { ReactComponent as ProjectsIcon } from 'new/components/icons/folder.svg';
import { ReactComponent as NexsetIcon } from 'new/components/icons/nexsetsOutline.svg';
import {
  RESOURCE_TYPE_CREDENTIAL_GROUP,
  RESOURCE_TYPE_CREDENTIALS,
  RESOURCE_TYPE_DATA_SET,
  RESOURCE_TYPE_FLOW,
  RESOURCE_TYPE_SINK,
  RESOURCE_TYPE_SOURCE,
} from 'js/constants/resourceTypes';
import { CARD_TYPE_API_KEY, CARD_TYPE_PROJECT } from 'js/constants/cardTypes';
import styles from './ResourceDetailHeader.module.scss';

export const connectionMap = {
  [RESOURCE_TYPE_DATA_SET]: {
    icon: <NexsetIcon className={styles.connectionIcon} />,
    label: 'Nexset',
    preposition: 'from',
  },
  [RESOURCE_TYPE_SOURCE]: {
    icon: <SourceIcon className={styles.connectionIcon} />,
    label: 'Source',
    preposition: 'from',
  },
  [RESOURCE_TYPE_SINK]: {
    icon: <DestinationIcon className={styles.connectionIcon} />,
    label: 'Destination',
    preposition: 'to',
  },
  [RESOURCE_TYPE_CREDENTIALS]: {
    icon: <LockIcon className={styles.connectionIcon} />,
    label: 'Credential',
    preposition: 'for',
  },
  [RESOURCE_TYPE_FLOW]: {
    icon: <FlowIcon className={styles.connectionIcon} />,
    label: 'Data Flow',
    preposition: 'from',
  },
  [CARD_TYPE_API_KEY]: {
    icon: <KeyIcon className={styles.connectionIcon} />,
    label: 'API Key',
  },
  [CARD_TYPE_PROJECT]: {
    icon: <ProjectsIcon className={styles.connectionIcon} />,
    label: 'Project',
  },
  [RESOURCE_TYPE_CREDENTIAL_GROUP]: {
    icon: <LockIcon className={styles.connectionIcon} />,
    label: 'Credential Group',
    preposition: 'for',
  },
};
